import type { QueryDataTier } from './types';

const MIN = 60_000;
const HOUR = 60 * MIN;
const DAY = 24 * HOUR;

export type TierQueryDefaults = {
  staleTime: number;
  gcTime: number;
  refetchOnWindowFocus: boolean;
  refetchOnReconnect: boolean;
  refetchOnMount: boolean | 'always';
  retry: number | boolean;
  refetchInterval?: number | false;
};

/** Cache / stale-time matrix aligned with SESSION_INIT cacheHints and performance audit. */
export const QUERY_TIER_DEFAULTS: Record<QueryDataTier, TierQueryDefaults> = {
  static: {
    staleTime: DAY,
    gcTime: 7 * DAY,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchOnMount: false,
    retry: 1,
    refetchInterval: false,
  },
  master: {
    staleTime: 6 * HOUR,
    gcTime: DAY,
    refetchOnWindowFocus: false,
    refetchOnReconnect: true,
    refetchOnMount: false,
    retry: 2,
    refetchInterval: false,
  },
  operational: {
    staleTime: 3 * MIN,
    gcTime: 30 * MIN,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
    refetchOnMount: true,
    retry: 2,
    refetchInterval: false,
  },
  dashboard: {
    staleTime: 2 * MIN,
    gcTime: 15 * MIN,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
    refetchOnMount: true,
    retry: 2,
    refetchInterval: 2 * MIN,
  },
  realtime: {
    staleTime: 0,
    gcTime: 5 * MIN,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
    refetchOnMount: true,
    retry: 1,
    refetchInterval: 30_000,
  },
};

export function tierOptions(tier: QueryDataTier, overrides?: Partial<TierQueryDefaults>) {
  return { ...QUERY_TIER_DEFAULTS[tier], ...overrides };
}
